import React from 'react'
import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import numeral from 'numeral'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../common/ui/colorBox'
import { CheckIcon } from '../../../common/ui/icons'
import { UNLIMIT } from '../../../constants'

const DetailsColorBox = styled('div')({
  borderRadius: 32,
  backgroundColor: '#CCCCFF',
  padding: 24,
  margin: `16px 0 0 0`
})

export function OnboardingPlan(props) {
  const { plan } = props

  return (
    <ColorBoxContent
      variant='outlined'
      style={{ width: '15vw', padding: '16px 16px', minWidth: '225px' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Typography variant='h5' sx={{ color: 'primary.dark', margin: '10px' }}>
          {plan.productName}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline'
          }}
        >
          <Typography
            variant='h2'
            sx={{ color: 'primary.dark', margin: '8px 8px' }}
          >
            {numeral(plan.baseplan.data * 1000).format('0b')}
          </Typography>
          <Typography
            variant='h3'
            sx={{ color: 'primary.dark', fontWeight: '400', margin: '10px 0' }}
          >
            {/* GB */}
          </Typography>
        </Box>
        <Typography variant='h3' sx={{ color: 'primary.dark', margin: '4px' }}>
          ${plan.baseplan.price.value}
        </Typography>
        <Typography sx={{ color: 'primary.dark', margin: '0px 0px 12px 0px' }}>
          per month
        </Typography>
        <DetailsColorBox>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CheckIcon />
              <Typography sx={{ color: 'primary.dark', margin: '0px 4px' }}>
                {plan.baseplan.voice < UNLIMIT
                  ? `${plan.baseplan.voice} mins `
                  : 'Unlimited'}
                Talktime
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CheckIcon />
              <Typography sx={{ color: 'primary.dark', margin: '0px 4px' }}>
                {plan.baseplan.sms < UNLIMIT ? plan.baseplan.sms : 'Unlimited'} SMS
              </Typography>
            </Box>
          </Box>
        </DetailsColorBox>
      </Box>
    </ColorBoxContent>
  )
}

OnboardingPlan.propTypes = {
  plan: PropTypes.object.isRequired
}
